var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroundrulesSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.791,
    height: 46.093,
    viewBox: "0 0 43.791 46.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17341",
    "data-name": "Group 17341",
    transform: "translate(-2.769 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25787",
    "data-name": "Path 25787",
    d: "M39.648,2H17.72a13.285,13.285,0,0,1,4.56,10.042,13.021,13.021,0,0,1-1.037,5.136H33.557a1.547,1.547,0,1,1,0,3.078H19.449c-.263.329-.56.658-.856.971a13.367,13.367,0,0,1-9.63,4.132,3.572,3.572,0,0,1-.593,0V44.8a3.292,3.292,0,0,0,3.292,3.292H39.648A3.292,3.292,0,0,0,42.94,44.8V5.292A3.292,3.292,0,0,0,39.648,2ZM33.557,32.915h-15.8a1.547,1.547,0,1,1,0-3.078h15.8a1.547,1.547,0,1,1,0,3.078Zm0-6.338h-15.8a1.531,1.531,0,0,1,0-3.062h15.8a1.531,1.531,0,1,1,0,3.062Z",
    transform: "translate(3.62 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25788",
    "data-name": "Path 25788",
    d: "M12.582,22.061a9.992,9.992,0,0,0,7.259-3.127,9.235,9.235,0,0,0,1.417-1.746,9.877,9.877,0,0,0,1.432-5.153,10.042,10.042,0,0,0-8.231-9.877h0a9.877,9.877,0,0,0-1.646-.148,10.025,10.025,0,0,0-.593,20.034,3.572,3.572,0,0,0,.362.016Zm-2.535-6.124L7.3,13.188A1.647,1.647,0,0,1,9.619,10.85L11.265,12.5l2.14-2.14,2.173-2.189A1.647,1.647,0,1,1,17.9,10.5l-5.169,5.07-.362.362a1.646,1.646,0,0,1-2.321,0Z",
    transform: "translate(0 0.006)",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundrulesSvg);
export default __webpack_public_path__ + "static/media/groundrules-svg.0afca4044306ef27907ba6bc06f18d70.svg";
export { ForwardRef as ReactComponent };